export default "__VITE_ASSET__bff7f7a4__"